import { ManagePracticeService } from './../../manage-practice/manage-practice.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from './../toast/alert.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Router } from '@angular/router';
declare var myExtObject: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private alertService: AlertService,
    private translateService: TranslateService,
    private appSettingService: AppSettingService,
    private managePracticeService: ManagePracticeService
  ) { }
  //showAddClaim: any = false;
  param: any;
  counter = 0;
  @Input() public title: string = " "
  public demoTitle: string = ""
  public showWarning: Number = 0;

  @Input() public additionalTitle: string = ""

  @Input() showHistoryButton: boolean = false;
  @Input() showAddAvailabilityButton: boolean = false;
  @Input() showAddClaim: boolean = false;
  @Input() redirecturl: string = "";
  @Input() claimUri: string = "/claims/new"
  @Input() showAddLacationsButton: boolean = false;
  @Input() showAddCounselorButton: boolean = false;
  @Input() showAddSiteButton: boolean = false;
  @Output() valueChange = new EventEmitter();
  @Input() showAddLicense: boolean = false;
  @Input() showAddLiability: boolean = false;
  
  redirectToAddCalim(event) { // You can give any function name

    this.managePracticeService.getBadges().subscribe(res => {
      setTimeout(() => {
        myExtObject.UpdateBadgeCount(res);
        
        if (this.appSettingService.loggedInUser.IsIndividual != 'True') {
          if (((!event.target.hasAttribute("markDisabled")) && (this.appSettingService.loggedInUser.AcknowledgeNotificationsCount == 0))) {
            this.router.navigate([this.claimUri]);
          }
          else {
            this.alertService.clear();
            if ((this.appSettingService.loggedInUser.AcknowledgeNotificationsCount > 0) && (event.target.hasAttribute("markDisabled"))) {
              this.alertService.warn('<li>' + this.translateService.instant("NewClaim.Buttons.NewClaimDisabledForNotifiation") + '</li><li>' + this.translateService.instant("NewClaim.Buttons.NewClaimDisabled") + '</li>', { time: 7000 })
            }
            else if (this.appSettingService.loggedInUser.AcknowledgeNotificationsCount > 0) {
              this.alertService.warn(this.translateService.instant("NewClaim.Buttons.NewClaimDisabledForNotifiation"), { time: 7000 })
            }
            else {
              this.alertService.warn(this.translateService.instant("NewClaim.Buttons.NewClaimDisabled"), { time: 7000 })
            }
          }
        }
        else {
          if ((this.appSettingService.loggedInUser.AcknowledgeNotificationsCount > 0) && (event.target.hasAttribute("markDisabled"))) {
            this.alertService.warn('<li>' + this.translateService.instant("NewClaim.Buttons.NewClaimDisabledForNotifiation") + '</li><li>' + this.translateService.instant("NewClaim.Buttons.NewClaimDisabled") + '</li>', { time: 7000 })
          }
          else if (this.appSettingService.loggedInUser.AcknowledgeNotificationsCount > 0) {
            this.alertService.warn(this.translateService.instant("NewClaim.Buttons.NewClaimDisabledForNotifiation"), { time: 7000 })
          }
          else if ((this.appSettingService.loggedInUser.AcknowledgeNotificationsCount == 0) && (event.target.hasAttribute("markDisabled"))) {
            this.alertService.warn('<li>' + this.translateService.instant("NewClaim.Buttons.NewClaimDisabled") + '</li>', { time: 7000 })
          }
          else {
            this.router.navigate([this.claimUri]);
          }
        }



      }, 50);
    });

  }
  ngOnInit() {
    if ((this.title == "ClaimList" || this.title == "History") && this.appSettingService.loggedInUser.IsNetworkCoach == 'False') {
      this.showAddClaim = true;
    }
    else {
      this.showAddClaim = false;
    }
  }



  backToPrevious() {
    if (this.redirecturl) {

      this.router.navigate([this.redirecturl]);
    }
    else {
      window.history.back();
    }
  }
}
